module.exports = __webpack_public_path__ + "img/freediving-6.d120e319.jpeg";